export const forgotPasswordAPIUrls = {
  forgotPass: '/auth/forgot-password',
  reset: '/auth/reset-password',
} as const;
